import { CircularProgress, Stack } from '@mui/material';
import React from 'react';

import { getDynamicBranding } from '../../theme/theme';

const { logo, brand } = getDynamicBranding();

const Loading = () => {
  return (
    <Stack spacing={5} direction="column" sx={{ alignItems: 'center' }}>
      <img height={50} src={logo} alt={`${brand} Logo`} style={{ zIndex: 1 }} />
      <CircularProgress />
    </Stack>
  );
};

export default Loading;
